import { Component, Input, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { DynamicDataListService } from './services/dynamic-data-list.service';
import { tap, first } from 'rxjs/operators';
import { CardListCell } from 'src/app/components/pages-partials/card-list/card-list-cell';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ColumnSortEvent, ColumnSortService } from './services/column-sort.service';
import { sortByColumn } from 'src/app/helpers/array.functions';
import { TmplAstVariable } from '@angular/compiler';

@Component({
    selector: 'app-dynamic-data-list-container',
    styleUrls: ['./dynamic-data-list.container.scss'],
    templateUrl: './dynamic-data-list.container.html',
    providers: [ColumnSortService],
    standalone: false
})
export class DynamicDataListContainer implements OnInit, AfterViewInit {
  @Input() title: string;
  @Input() pagination: boolean;
  @Input() useUrlParameters: boolean;
  @Input() tryToUseLazyLoadingPagination: boolean;
  @Input() itemsPerPage: number;
  @Input() cellProps: CardListCell[] = [];
  @Input() tableSizeClass: string;
  @Input() tableClass: string;
  @Input() serverType: string;
  @Input() showSearch: boolean;
  @ViewChild('search') search: ElementRef;

  allItems: any[];
  displayItems: any[];
  totalCount: number;
  isLoading: boolean = false;
  lazyLoadingPagination: boolean;
  initialized = false;
  animateSearch = false;

  private currPage: number = 1;

  private _tableWrapper: ElementRef;
  get tableWrapper(): ElementRef {
    return this._tableWrapper;
  }
  @ViewChild('tableWrapper') set tableWrapper(tableWrapper: ElementRef) {
    if (tableWrapper) {
      this._tableWrapper = tableWrapper;
      this.adjustTableMinimumHeight(tableWrapper);
    }
  }

  private _itemsSourceUrl: string;
  get itemsSourceUrl(): string {
    return this._itemsSourceUrl;
  }
  @Input() set itemsSourceUrl(itemsSourceUrl: string) {
    this._itemsSourceUrl = itemsSourceUrl;
    if (this.initialized)
      // listen to url changes only after component is initialized
    
    this.downloadListData(itemsSourceUrl);
  }

  constructor(
    private dynamicDataListService: DynamicDataListService,
    private activatedRoute: ActivatedRoute,
    private sortService: ColumnSortService,
    private router: Router
  ) {}


  ngOnInit() {
     this.activatedRoute.queryParams.subscribe(params => {
        const search = params.search;
        this.showSearch = !!search;

        if (search) {
          this.filter(search);
        } else {
          this.displayItems = this.getDisplayItems(this.allItems, this.currPage);
        }
      });
      
    this.sortService.sortColumn$.subscribe(sortEvent => this.sortItems(sortEvent));

    if (!this.tryToUseLazyLoadingPagination || !this.itemsPerPage)
      this.downloadListData(this.itemsSourceUrl, this.serverType, null, null, false);
    else {
      let initialPage = 1;
      if (this.useUrlParameters) {
        const { page } = this.activatedRoute.snapshot.queryParams;
        const pageNumber = Number(page);
        if (!isNaN(pageNumber)) initialPage = pageNumber;
      }
      this.downloadListData(
        this.itemsSourceUrl,
        this.serverType,
        initialPage,
        this.itemsPerPage,
        false
      );
    }
    this.initialized = true;

  }

  ngAfterViewInit() {
 console.log(this.search);
    const searchParam = this.activatedRoute.snapshot.queryParams['search'];

    if (searchParam) {
      this.showSearch = true;
      this.animateSearch = true;
    }

    if (searchParam && this.search) {
      this.search.nativeElement.value = searchParam;     
    
    }
  }

  private downloadListData(
    url: string,
    serverType?: string,
    page?: number,
    perPage?: number,
    useCache: boolean = true
  ): Subscription {
    this.isLoading = true;
    return this.dynamicDataListService
      .getItems(url, serverType, page, perPage, useCache)
      .pipe(
        first(),
        tap((response) => {
          this.lazyLoadingPagination = response.items.length < response.totalCount;
          const queryParams = { ...this.activatedRoute.snapshot.queryParams, search:null }
        
          response.items.forEach((currentValue, index) => {                            
                response.items[index]= 
                { 
                  ...this.activatedRoute.snapshot.params, 
                  ...queryParams, 
                  ...currentValue
                };
          });
         
          this.allItems = response.items;
          if (this.activatedRoute.snapshot.queryParams['search']){
            this.filter(this.activatedRoute.snapshot.queryParams['search']);   
          }
          else{
            this.displayItems = this.getDisplayItems(response.items, page);
          }
                
          this.totalCount = response.totalCount;
          this.isLoading = false;
          
        })
      )
      .subscribe(() => {
      });
    }


    private getTitle(title: string) {
    
        if (title.indexOf('{') !== -1) {
          var regex1 = /\{([^{}]*)\}/g;
          const params = { ...this.activatedRoute.snapshot.params, ...this.activatedRoute.snapshot.queryParams };
          var matches = title.match(regex1);
          for (var i = 0; i < matches.length; i++) {
              var str = matches[i];
              title = title.replace(str, params[str.replace('{','').replace('}','')]).replace('/','');
          }
    }
      
     return title;
  }

  searchSubmit(searchValue:string) {
    this.router.navigate([], { queryParams: { search: searchValue }, queryParamsHandling: 'merge' });
    this.filter(searchValue);
  }

  private filter(searchValue:string) {
  
     const filtered = this.allItems.filter(item => JSON.stringify(item).toLowerCase().indexOf(searchValue.toLowerCase()) !== -1); 
     this.displayItems = this.getDisplayItems(filtered, 1);
  }

  private sortItems(sortEvent: ColumnSortEvent) {
    console.log(sortEvent);
    console.log("lazy", this.lazyLoadingPagination);
    if (!this.lazyLoadingPagination) {
      this.allItems = this.allItems.sort(sortByColumn(sortEvent));
      this.displayItems = this.getDisplayItems(this.allItems, this.currPage);
    }
  }

  getDisplayItems(items: any[], pageNo: number): any[] {
    this.currPage = pageNo;
    if (this.pagination && !this.lazyLoadingPagination) {
      const startIndex = (pageNo - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return items.slice(
        startIndex,
        endIndex < items.length ? endIndex : items.length
      );
    }

    return items;
  }
  onClickSearchIcon(){
    this.showSearch = true;
    setTimeout(() => {
      this.animateSearch = true;
    });
    setTimeout(() => {
       this.search.nativeElement.focus();
    }, 300);
   
  }

  onPageChange(pageNo: number) {
    if (!this.lazyLoadingPagination) {
      this.displayItems = this.getDisplayItems(this.allItems, pageNo);
    } else {
      this.downloadListData(this.itemsSourceUrl, this.serverType, pageNo, this.itemsPerPage);
    }

    this.adjustTableMinimumHeight(this.tableWrapper);
  }

  adjustTableMinimumHeight(wrapper: ElementRef) {
    if (!wrapper) return;

    const div = wrapper.nativeElement as HTMLElement;
    const { offsetHeight, style } = div;
    const { minHeight } = style;
    const minHeightNumber = Number(
      minHeight.substring(0, minHeight.indexOf('px'))
    );

    const bodyHeight = document.getElementsByTagName('body')[0].offsetHeight;
    if (offsetHeight > minHeightNumber && offsetHeight < bodyHeight) {
      div.style.minHeight = `${offsetHeight}px`;
    }

    if (offsetHeight > bodyHeight) {
      // scroll to top if content is bigger than page body
      const appContent = document.getElementById('app-content');
      appContent.scrollTo(0, 0);
    }
  }
}
